import module from 'module';

const templateUrl = require('./checks-list.template.html');
module.component('checksList', {
  templateUrl: templateUrl,
  controller: function () {
    const that = this;

    // By default set display mode to 'INCOMING'
    that.displayMode = 'INCOMING';

    that.setDisplayMode = (mode) => {
      that.displayMode = mode;
    }
  }
});
